export enum CurrencyType {
  Pickem = 'Pickem',
  WebCoin = 'Web Coin',
  ClubCoin = 'Club Coin',
  Ruby = 'Ruby',
}
